interface PaginationProps {
  total: number;
  limit: number;
  offset: number;
  onPrev: () => void;
  onNext: () => void;
}

export default function Pagination({ total, limit, offset, onPrev, onNext }: PaginationProps) {
  if (total <= limit) return null;

  return (
    <div className="flex items-center justify-between border-t border-gray-100 px-5 py-3 dark:border-gray-800">
      <span className="text-xs text-gray-500 dark:text-gray-400">
        Showing {offset + 1}–{Math.min(offset + limit, total)} of {total}
      </span>
      <div className="flex gap-2">
        <button
          type="button"
          onClick={onPrev}
          disabled={offset === 0}
          className="h-8 rounded-lg border border-gray-300 px-3 text-xs font-medium text-gray-700 shadow-theme-xs hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-700"
        >
          Previous
        </button>
        <button
          type="button"
          onClick={onNext}
          disabled={offset + limit >= total}
          className="h-8 rounded-lg border border-gray-300 px-3 text-xs font-medium text-gray-700 shadow-theme-xs hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-700"
        >
          Next
        </button>
      </div>
    </div>
  );
}
